"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentWidget = void 0;
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const store_1 = require("client/modules/dashboard/store");
const store_2 = require("client/modules/users/store");
const material_ui_icons_1 = require("material-ui-icons");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const capitalize_string_1 = require("shared/util/capitalize-string");
require("./payment-widget.less");
const moment = require("moment");
const throttle_debounce_1 = require("throttle-debounce");
let PaymentWidget = class PaymentWidget extends React.Component {
    constructor() {
        super(...arguments);
        this.order = "ASC";
        this.orderBy = "orderId";
        this.unpaidOrders = [];
        // C-097 Outstanding Payments
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        // private pageSettings: any = {
        //   table: {
        //     order: "ASC",
        //     orderBy: "orderId"
        //   }
        // };
        this.columns = [
            {
                id: "orderId",
                numeric: true,
                label: "Order #"
            },
            {
                id: "orderDate",
                numeric: false,
                label: "Order Date"
            },
            {
                id: "patientName",
                numeric: false,
                label: "Patient"
            },
            {
                id: "siteName",
                numeric: false,
                label: "Pharmacy"
            },
            {
                id: "paymentDue",
                numeric: true,
                label: "Balance Due"
            }
        ];
        this.renderTableRow = (row, index) => {
            const patientName = `${row.patient.firstName} ${row.patient.lastName}`;
            const siteName = row.site.name;
            return (React.createElement(list_item_1.MaterialListItem, { className: "payment__list--row", key: index, to: `/claims/${row.order.id}/payment` },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.order.id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: moment(row.order.createDate).format("MM/DD/YYYY") }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(patientName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(siteName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: `$${(row.due / 100).toFixed(2)}` })));
        };
        this.getPaymentWidgets = throttle_debounce_1.debounce(200, async () => {
            const options = {
                count: 100,
                order: this.order,
                sort: this.orderBy,
                start: 0,
                page: this.page,
                limit: this.limit // C-097 Outstanding Payments
            };
            const result = await store_1.dashboardStore.getPaymentWidget(options);
            if (result.success) {
                this.unpaidOrders = result.orders.map((e) => e);
            }
            else {
                console.log(result.error);
            }
        });
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.getPaymentWidgets();
        };
    }
    async componentDidMount() {
        const options = {
            //B-035
            count: 100,
            order: this.order,
            // siteId: this.siteId,
            sort: this.orderBy,
            start: 0,
            page: this.page,
            limit: this.limit // C-097 Outstanding Payments
        };
        const result = await store_1.dashboardStore.getPaymentWidget(options);
        // C-097 Outstanding Payments
        this.totalPages = store_1.dashboardStore.totalProviderPage;
        if (result.success) {
            this.unpaidOrders = result.orders.map((e) => e);
        }
        else {
            console.log(result.error);
        }
    }
    render() {
        return (React.createElement("div", { className: "payment-widget widget widgetTable paymentWidget-wrapper" }, store_2.usersStore.permissions.ViewPaymentWidget ? (React.createElement(React.Fragment, null, !!this.unpaidOrders.length ? (React.createElement(React.Fragment, null,
            React.createElement(list_1.MaterialList, { className: "payment__list", columns: this.columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: this.unpaidOrders, renderRow: this.renderTableRow }),
            React.createElement("div", { className: "pagination-container-header" },
                React.createElement("button", { className: "btn-pagination", onClick: () => {
                        if (this.page === 1)
                            return;
                        this.page--;
                        this.getPaymentWidgets();
                    } }, "Previous"),
                React.createElement("div", { className: "pagination-container" },
                    React.createElement("p", null, "Page"),
                    React.createElement("select", { className: "pagination-input", onChange: (e) => {
                            this.limit = Number(e.target.value);
                            this.page = 1;
                            this.getPaymentWidgets();
                        }, defaultValue: this.limit },
                        React.createElement("option", { value: "5" }, "5 rows"),
                        React.createElement("option", { value: "10" }, "10 rows"),
                        React.createElement("option", { value: "25" }, "25 rows"),
                        React.createElement("option", { value: "50" }, "50 rows"),
                        React.createElement("option", { value: "100" }, "100 rows"))),
                React.createElement("button", { className: "btn-pagination1", onClick: () => {
                        this.page + 1;
                        this.getPaymentWidgets();
                    } }, "Next")))) : (React.createElement("p", { style: { textAlign: "center" } },
            "There are currently no outstanding payments.",
            React.createElement("br", null),
            React.createElement(material_ui_icons_1.CheckCircle, { style: {
                    width: "3em",
                    height: "3em",
                    opacity: 0.25,
                    margin: "1em 0"
                } }))))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "unpaidOrders", void 0);
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], PaymentWidget.prototype, "totalPages", void 0);
PaymentWidget = __decorate([
    mobx_react_1.observer
], PaymentWidget);
exports.PaymentWidget = PaymentWidget;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/dashboard/modules/widget-grid/components/payment-widget/payment-widget.tsx
// module id = 3365
// module chunks = 0